import type { TFunction } from "i18next";
import type { ChangeEventHandler, ComponentProps, FocusEventHandler } from "react";
import { withTranslation } from "react-i18next";
import { Text } from "../elements";
import { SkeletonLoader } from "@hubertai/hubert-component-library";

interface DropdownProps extends ComponentProps<"select"> {
    label: string;
    helpText?: string;
    options: Array<OptionType>;
    handleChange: ChangeEventHandler<HTMLSelectElement>;
    handleBlur: FocusEventHandler<HTMLSelectElement>;
    error?: string;
    touched?: boolean;
    t: TFunction;
    loading?: boolean;
    placeholder: string;
}

type OptionType = {
    name: string;
    value: string | number;
};

const Dropdown = ({
    label,
    name,
    id = "",
    placeholder,
    helpText = "",
    options,
    handleChange,
    handleBlur,
    value,
    error = "",
    touched = false,
    t,
    loading = false,
}: DropdownProps) =>
    loading ? (
        <SkeletonLoader height="46px" />
    ) : (
        <div className="form-group">
            <label htmlFor={name} className="form-label">
                {label}
            </label>
            <select
                id={id}
                onChange={handleChange}
                onBlur={handleBlur}
                name={name}
                value={value}
                className={`form-select ${error && touched ? "error" : ""}`.trim()}
            >
                <option value="" disabled>
                    {placeholder}
                </option>
                {options.map((option) => (
                    <option value={option.value} key={option.name}>
                        {option.name}
                    </option>
                ))}
            </select>
            {helpText && (
                <Text size="small" block className="help-text">
                    {helpText}
                </Text>
            )}
            {error && touched && (
                <Text size="small" block className="form-error">
                    {t(error)}
                </Text>
            )}
        </div>
    );

export default withTranslation()(Dropdown);
